import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useQuery } from 'react-query';

import { useReportScope } from '@ge/feat-reporting/hooks/use-report-scope';
import { WidgetNames } from '@ge/feat-reporting/models/widgets';
import { AlertsEntityType, AssetType, EntityType, QueryKey } from '@ge/models/constants';
import { DateTimeFormats } from '@ge/models/constants';
import { InputEntityType } from '@ge/serverless-models/src/rendigital/enums';
import { Config } from '@ge/shared/data-hooks';
import { fetchReportingAssetsData } from '@ge/shared/services/kpi';

dayjs.extend(isoWeek);
export const useWidgetAssetTable = ({
  endDate: _endDate,
  isActive = true,
  name,
  startDate: _startDate,
}) => {
  const { siteIds, scope, scopeType } = useReportScope();
  let endDate = _endDate;
  let startDate = _startDate;

  if (name === WidgetNames.ASSET_TABLE) {
    // Backend endpoint for this data will return an error if any future dates are passed
    const currentDate = dayjs();
    if (dayjs(endDate) > currentDate) {
      endDate = currentDate;
    }
    if (dayjs(startDate) > currentDate) {
      startDate = currentDate;
    }
  }

  const params = {
    startDate: dayjs(startDate).format(DateTimeFormats.ENDPOINT_PARAM),
    endDate: dayjs(endDate).format(DateTimeFormats.ENDPOINT_PARAM),
    entityAggr: AlertsEntityType.WIND_TURBINE,
    entityType: scopeType === EntityType.CONTRACT ? InputEntityType.TURBINE : AssetType.SITE,
    siteIds: scopeType === EntityType.CONTRACT ? scope?.srcassetid : siteIds,
  };

  const {
    data: _data,
    error,
    isLoading,
  } = useQuery([QueryKey.REPORTING_ASSETS, params], () => fetchReportingAssetsData(params), {
    ...Config.EXECUTE_ONCE,
    enabled: isActive,
  });
  return { data: _data, error, isLoading };
};
